(() => {
  const enhanceContextReturn = (link) => {
    const from = new URLSearchParams(window.location.search).get("from");
    let href = link.dataset.defaultHref;
    let label = link.dataset.defaultLabel;

    if (from === "mesh") {
      href = link.dataset.meshHref || href;
      label = link.dataset.meshLabel || label;
    } else if (from === "waterResistant") {
      href = link.dataset.waterResistantHref || href;
      label = link.dataset.waterResistantLabel || label;
    }

    if (href) link.href = href;
    if (label) link.textContent = label;
  };

  const enhanceResearchLink = (link) => {
    if (!link.dataset.baseUrl) return;

    try {
      const incoming = new URLSearchParams(window.location.search);
      const destination = new URL(link.dataset.baseUrl, window.location.origin);
      const source = incoming.get("source") || incoming.get("utm_source") || link.dataset.defaultSource;
      const campaignDetail = [incoming.get("utm_campaign"), incoming.get("utm_content")]
        .filter(Boolean)
        .join(":");
      const sourceDetail = incoming.get("source_detail")
        || campaignDetail
        || `${link.dataset.sourceDetailPrefix}_${link.dataset.locale}`;

      destination.searchParams.set("source", source);
      destination.searchParams.set("source_detail", sourceDetail);
      destination.searchParams.set("route_type", link.dataset.routeType);
      destination.searchParams.set("research_round", link.dataset.researchRound);
      destination.searchParams.set("form_version", link.dataset.formVersion);
      destination.searchParams.set("privacy_version", link.dataset.privacyVersion);
      link.href = destination.toString();
    } catch {
      // Keep the verified base Tally URL as the no-enhancement fallback.
    }
  };

  const init = (root = document) => {
    root.querySelectorAll("[data-footle-context-return]").forEach(enhanceContextReturn);
    root.querySelectorAll("[data-footle-research-link]").forEach(enhanceResearchLink);
  };

  if (window.FootleStaticPages) {
    window.FootleStaticPages.init(document);
    return;
  }

  window.FootleStaticPages = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
